const TABBY_PROMO_HOST = "checkout.tabby.ai";

// The promo URL comes from the BE so it carries the store's own merchant code and public key;
// only allow Tabby's host into the iframe.
export function isTabbyPromoUrl(url) {
  if (typeof url !== "string") return false;
  try {
    const { protocol, hostname } = new URL(url);
    return protocol === "https:" && hostname === TABBY_PROMO_HOST;
  } catch {
    return false;
  }
}

// The BE sends a web-specific URL next to the shared one; the shared one covers backends that do
// not send it yet.
export function getTabbyPromoUrl(moreInfo) {
  return [moreInfo?.url_web, moreInfo?.url].find(isTabbyPromoUrl) ?? null;
}
